<template>
  <el-dialog class="rc-dialog" title="考试学员导入" :visible.sync="importInfo.show" @close="closeDialog"
    :close-on-click-modal="false" destroy-on-close width="45%">
    <el-form ref="curdForm" size="small" label-position="right" label-width="100px">
      <el-form-item>
        <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
      </el-form-item>

      <el-form-item required label="附件：" error="请上传附件" :show-message="file == null">
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { importExamUser } from "@/api/examInfo";
import { examCollageTemplate } from "@/assets/excel/index.js";
import butn from "@/components/button/index";
import Upload from "@/components/upload/excel";
import vue from "@/main";
import { downloadByUrl } from "../../../utils/common";
export default {
  components: { butn, Upload },
  data() {
    return {
      CUFlag: false,
      examId: "",
      file: null,
      EXCP: examCollageTemplate,
    };
  },
  props: {
    importInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          id: 0,
        };
      },
    }
  },
  created() {
    // vue.$on("importExcel", (item) => {
    //   this.$nextTick(() => {
    //     this.CUFlag = true;
    //     this.examId = item;
    //   });
    // });
  },
  methods: {
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("examId", this.importInfo.id);
        formData.append("file", this.file);
        importExamUser(formData).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data != null) {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              this.closeDialog();
            } else {
              this.$message.success(res.msg);
              vue.$emit("tableInit");
              this.closeDialog();
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.closeDialog();
          }
        });
      }
    },
    closeDialog() {

      if (this.file) {
        // 数据重置
        this.file = null;
      }
      this.$emit("closeImport");
    },
    downloadTemplate() {
      downloadByUrl(null, this.EXCP)
    }
  }
};
</script>
